var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 740,
    height: 597.632,
    viewBox: "0 0 740 597.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mesa_de_trabajo_1",
    "data-name": "Mesa de trabajo 1",
    transform: "translate(-51.21 -27.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(51.21 27.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M116.628.027C179.771-1.228,229.94,40.965,228.684,94.269s-53.461,97.534-116.6,98.789S-1.233,152.121.023,98.817,53.484,1.283,116.628.027Z",
    transform: "matrix(0.125, -0.992, 0.992, 0.125, 262.748, 226.706)",
    fill: "#ffd12d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M198.828,131.3c-1.261-19.658-15.021-34.843-31.574-34.843S136.941,111.641,135.68,131.3Z",
    transform: "translate(-38.483 -1.423)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M228.2,137.382c8.069-15.843,5.293-36.318-6.552-48.331s-29.258-12.013-41.1,0-14.621,32.488-6.552,48.331Z",
    transform: "translate(-33.656 -7.505)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M261.189,130.487C258.764,112.155,245.5,98.65,229.919,98.65s-28.845,13.5-31.269,31.837Z",
    transform: "translate(-29.311 -0.611)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M557.048,131.3c-1.261-19.658-15.021-34.843-31.574-34.843S495.161,111.641,493.9,131.3Z",
    transform: "translate(14.543 -1.423)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M586.42,137.382c8.069-15.843,5.293-36.318-6.552-48.331s-29.258-12.013-41.1,0-14.621,32.488-6.552,48.331Z",
    transform: "translate(19.55 -7.505)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M619.409,130.487c-2.424-18.332-15.688-31.837-31.269-31.837s-28.845,13.5-31.269,31.837Z",
    transform: "translate(23.717 -0.611)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 88.371,
    height: 417.939,
    transform: "translate(362.588 107.784)",
    fill: "#abaab0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 10.943,
    height: 14.747,
    transform: "translate(367.659 152.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 10.943,
    height: 14.747,
    transform: "translate(383.89 152.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 10.943,
    height: 14.747,
    transform: "translate(400.132 152.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 10.943,
    height: 14.747,
    transform: "translate(416.363 152.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 10.943,
    height: 14.747,
    transform: "translate(432.594 152.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 10.943,
    height: 14.747,
    transform: "translate(367.659 195.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 10.943,
    height: 14.747,
    transform: "translate(383.89 195.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 10.943,
    height: 14.747,
    transform: "translate(400.132 195.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 10.943,
    height: 14.747,
    transform: "translate(416.363 195.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 10.943,
    height: 14.747,
    transform: "translate(432.594 195.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 10.943,
    height: 14.747,
    transform: "translate(367.659 237.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 10.943,
    height: 14.747,
    transform: "translate(383.89 237.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 10.943,
    height: 14.747,
    transform: "translate(400.132 237.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 10.943,
    height: 14.747,
    transform: "translate(416.363 237.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 10.943,
    height: 14.747,
    transform: "translate(432.594 237.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 10.943,
    height: 14.747,
    transform: "translate(367.659 280.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 10.943,
    height: 14.747,
    transform: "translate(383.89 280.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 10.943,
    height: 14.747,
    transform: "translate(400.132 280.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 10.943,
    height: 14.747,
    transform: "translate(416.363 280.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 10.943,
    height: 14.747,
    transform: "translate(432.594 280.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 10.943,
    height: 14.747,
    transform: "translate(367.659 322.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 10.943,
    height: 14.747,
    transform: "translate(383.89 322.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 10.943,
    height: 14.747,
    transform: "translate(400.132 322.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 10.943,
    height: 14.747,
    transform: "translate(416.363 322.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 10.943,
    height: 14.747,
    transform: "translate(432.594 322.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 10.943,
    height: 14.747,
    transform: "translate(367.659 364.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 10.943,
    height: 14.747,
    transform: "translate(383.89 364.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 10.943,
    height: 14.747,
    transform: "translate(400.132 364.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 10.943,
    height: 14.747,
    transform: "translate(416.363 364.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 10.943,
    height: 14.747,
    transform: "translate(432.594 364.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 21.736,
    height: 126.677,
    transform: "translate(373.105 391.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 21.736,
    height: 126.677,
    transform: "translate(416.421 391.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M608.992,437.6V339.529h8.653V437.6h.564V338.94H608.44V437.6Z",
    transform: "translate(31.487 88.421)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 9.205,
    height: 0.672,
    transform: "translate(640.203 438.243)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 8.929,
    y2: 10.567,
    transform: "translate(640.479 428.019)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x1: 8.929,
    y2: 10.567,
    transform: "translate(640.479 428.019)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 9.205,
    height: 0.672,
    transform: "translate(640.203 449.138)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(640.479 438.914)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(640.479 438.914)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 9.205,
    height: 0.672,
    transform: "translate(640.203 460.034)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(640.479 449.81)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(640.479 449.81)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 9.205,
    height: 0.672,
    transform: "translate(640.203 470.93)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(640.479 460.705)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(640.479 460.705)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 9.205,
    height: 0.672,
    transform: "translate(640.203 481.811)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 8.929,
    y2: 10.567,
    transform: "translate(640.479 471.587)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x1: 8.929,
    y2: 10.567,
    transform: "translate(640.479 471.587)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 9.205,
    height: 0.672,
    transform: "translate(640.203 492.707)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x2: 8.929,
    y2: 10.567,
    transform: "translate(640.479 482.483)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 8.929,
    y2: 10.567,
    transform: "translate(640.479 482.483)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 9.205,
    height: 0.672,
    transform: "translate(640.203 503.603)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(640.479 493.379)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(640.479 493.379)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 9.205,
    height: 0.672,
    transform: "translate(640.203 514.498)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(640.479 504.274)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(640.479 504.274)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 9.769,
    height: 0.672,
    transform: "translate(639.927 525.394)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    x2: 8.929,
    y2: 10.567,
    transform: "translate(640.479 515.156)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x1: 8.929,
    y2: 10.567,
    transform: "translate(640.479 515.156)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M351.407,516.127H277.5V126.16l73.907,40.43Z",
    transform: "translate(-17.607 9.582)",
    fill: "#e7e8ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 9.148,
    height: 12.335,
    transform: "translate(264.118 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 9.148,
    height: 12.335,
    transform: "translate(277.695 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 9.148,
    height: 12.335,
    transform: "translate(291.273 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 9.148,
    height: 12.335,
    transform: "translate(304.85 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 9.148,
    height: 12.335,
    transform: "translate(318.428 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 9.148,
    height: 12.335,
    transform: "translate(264.118 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 9.148,
    height: 12.335,
    transform: "translate(277.695 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 9.148,
    height: 12.335,
    transform: "translate(291.273 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 9.148,
    height: 12.335,
    transform: "translate(304.85 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 9.148,
    height: 12.335,
    transform: "translate(318.428 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 9.148,
    height: 12.335,
    transform: "translate(264.118 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 9.148,
    height: 12.335,
    transform: "translate(277.695 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 9.148,
    height: 12.335,
    transform: "translate(291.273 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 9.148,
    height: 12.335,
    transform: "translate(304.85 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 9.148,
    height: 12.335,
    transform: "translate(318.428 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 9.148,
    height: 12.335,
    transform: "translate(264.118 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 9.148,
    height: 12.335,
    transform: "translate(277.695 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 9.148,
    height: 12.335,
    transform: "translate(291.273 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 9.148,
    height: 12.335,
    transform: "translate(304.85 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 9.148,
    height: 12.335,
    transform: "translate(318.428 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 9.148,
    height: 12.335,
    transform: "translate(264.118 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 9.148,
    height: 12.335,
    transform: "translate(277.695 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 9.148,
    height: 12.335,
    transform: "translate(291.273 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 9.148,
    height: 12.335,
    transform: "translate(304.85 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 9.148,
    height: 12.335,
    transform: "translate(318.428 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 9.148,
    height: 12.335,
    transform: "translate(264.118 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 9.148,
    height: 12.335,
    transform: "translate(277.695 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 9.148,
    height: 12.335,
    transform: "translate(291.273 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 9.148,
    height: 12.335,
    transform: "translate(304.85 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 9.148,
    height: 12.335,
    transform: "translate(318.428 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 18.18,
    height: 105.941,
    transform: "translate(268.672 413.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 18.18,
    height: 105.941,
    transform: "translate(304.901 413.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 30.332,
    height: 121.14,
    transform: "translate(653.389 408.256)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M645.323,375.642H624.611a2.537,2.537,0,0,1-2.3-2.673h0a2.928,2.928,0,0,1,.678-1.91,2.05,2.05,0,0,1,1.623-.749h20.712a2.534,2.534,0,0,1,2.3,2.659h0A2.537,2.537,0,0,1,645.323,375.642Z",
    transform: "translate(33.576 100.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M645.323,348.955H624.611a2.537,2.537,0,0,1-2.3-2.673h0a2.537,2.537,0,0,1,2.3-2.673h20.712a2.537,2.537,0,0,1,2.3,2.673h0A2.537,2.537,0,0,1,645.323,348.955Z",
    transform: "translate(33.576 90.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M645.323,402.345H624.611a2.537,2.537,0,0,1-2.3-2.672h0a2.537,2.537,0,0,1,2.3-2.673h20.712a2.537,2.537,0,0,1,2.3,2.673h0A2.537,2.537,0,0,1,645.323,402.345Z",
    transform: "translate(33.576 109.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 23.255,
    height: 19.886,
    rx: 4.84,
    transform: "translate(656.933 411.901)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 23.255,
    height: 19.886,
    rx: 4.84,
    transform: "translate(656.933 444.095)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 23.255,
    height: 19.886,
    rx: 4.84,
    transform: "translate(656.933 481.208)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 53.932,
    height: 255.081,
    transform: "translate(161.648 270.587)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 12.611,
    height: 248.735,
    transform: "translate(167.879 275.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 12.611,
    height: 248.735,
    transform: "translate(196.217 275.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M179.63,465.565V183.417H154.741V465.565H153.13V181.69h28.111V465.565Z",
    transform: "translate(-35.854 30.157)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_108",
    "data-name": "Rectangle 108",
    width: 26.488,
    height: 1.919,
    transform: "translate(118.093 243.191)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M.154,3.458,39.787,0l-.154,1.766L0,5.224Z",
    transform: "matrix(0.71, -0.705, 0.705, 0.71, 114.968, 241.135)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.97, 216.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 26.488,
    height: 1.919,
    transform: "translate(118.093 274.521)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M.154,3.458,39.788,0l-.154,1.766L0,5.224Z",
    transform: "translate(114.98 272.447) rotate(-44.8)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.982, 248.117)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 26.488,
    height: 1.919,
    transform: "translate(118.093 305.865)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M.154,3.458,39.783,0l-.154,1.766L0,5.224Z",
    transform: "matrix(0.71, -0.704, 0.704, 0.71, 114.974, 303.75)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.974, 279.44)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    width: 26.488,
    height: 1.919,
    transform: "translate(118.093 337.195)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M.154,3.458,39.782,0l-.154,1.766L0,5.224Z",
    transform: "matrix(0.71, -0.704, 0.704, 0.71, 114.962, 335.151)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.975, 310.787)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_120",
    "data-name": "Rectangle 120",
    width: 26.488,
    height: 1.919,
    transform: "translate(118.093 368.538)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M.154,3.458,39.783,0l-.154,1.766L0,5.224Z",
    transform: "matrix(0.71, -0.704, 0.704, 0.71, 114.974, 366.425)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.979, 342.11)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    width: 26.488,
    height: 1.919,
    transform: "translate(118.093 399.868)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M.154,3.458,39.782,0l-.154,1.766L0,5.224Z",
    transform: "matrix(0.71, -0.704, 0.704, 0.71, 114.955, 397.821)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.98, 373.443)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 26.488,
    height: 1.919,
    transform: "translate(118.093 431.212)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M.154,3.458,39.782,0l-.154,1.766L0,5.224Z",
    transform: "matrix(0.71, -0.704, 0.704, 0.71, 114.956, 429.167)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.981, 404.804)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 26.488,
    height: 1.919,
    transform: "translate(118.093 462.542)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M.154,3.458,39.783,0l-.154,1.766L0,5.224Z",
    transform: "matrix(0.71, -0.704, 0.704, 0.71, 114.979, 460.442)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.985, 436.113)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 28.111,
    height: 1.919,
    transform: "translate(117.287 493.886)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M.154,3.458,39.782,0l-.154,1.766L0,5.224Z",
    transform: "matrix(0.71, -0.704, 0.704, 0.71, 114.961, 491.851)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M3.458.154,5.224,0,1.766,39.633,0,39.787Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 114.985, 467.46)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_135",
    "data-name": "Rectangle 135",
    width: 12.749,
    height: 31.124,
    transform: "translate(288.869 244.356)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 1.899,
    height: 15.432,
    transform: "translate(294.287 273.233)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_137",
    "data-name": "Rectangle 137",
    width: 1.899,
    height: 5.29,
    transform: "translate(294.287 308.852)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M309.353,259.372h-1.036c-2.269,0-4.108-2.191-4.108-4.893V241.323c0-2.7,1.839-4.893,4.108-4.893h1.036c2.269,0,4.108,2.191,4.108,4.893v13.116a5.414,5.414,0,0,1-1.191,3.486,3.809,3.809,0,0,1-2.917,1.448Zm-1.036-20.983a2.767,2.767,0,0,0-2.5,2.974V254.48a2.767,2.767,0,0,0,2.5,2.974h1.036a2.767,2.767,0,0,0,2.5-2.974V241.323a2.78,2.78,0,0,0-2.5-2.974Z",
    transform: "translate(-13.592 50.439)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 12.749,
    height: 31.124,
    transform: "translate(246.38 244.356)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 1.899,
    height: 15.432,
    transform: "translate(251.647 273.233)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 1.899,
    height: 5.29,
    transform: "translate(251.647 308.852)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M272.223,259.372H271.2c-2.271,0-4.113-2.188-4.119-4.893V241.323c.006-2.7,1.849-4.893,4.119-4.893h1.024c2.269,0,4.108,2.191,4.108,4.893v13.116a5.414,5.414,0,0,1-1.191,3.486A3.809,3.809,0,0,1,272.223,259.372ZM271.2,238.39a2.777,2.777,0,0,0-2.508,2.974V254.48a2.777,2.777,0,0,0,2.508,2.974h1.024a2.767,2.767,0,0,0,2.5-2.974V241.323a2.767,2.767,0,0,0-2.5-2.974Z",
    transform: "translate(-19.113 50.439)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M168.177,194.854H153V151.34h15.166Zm-13.555-1.919h11.944V153.259H154.622Z",
    transform: "translate(-35.874 18.912)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 13.555,
    height: 1.919,
    transform: "translate(117.943 183.135)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 13.394,
    height: 2.028,
    transform: "translate(117.943 197.731)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M371.816,183.609H109.591v29.631H371.816v1.919H107.98V181.69H371.816Z",
    transform: "translate(-42.657 30.157)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 1.611,
    height: 31.549,
    transform: "translate(91.639 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    width: 1.611,
    height: 31.549,
    transform: "translate(117.138 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M3.458.154,5.222,0,1.764,39.682,0,39.836Z",
    transform: "translate(63.807 216.746) rotate(-44.8)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 63.801, 241.374)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M3.458.154,5.222,0,1.764,39.684,0,39.837Z",
    transform: "matrix(0.71, -0.705, 0.705, 0.71, 89.301, 216.782)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 89.31, 241.327)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 1.611,
    height: 31.549,
    transform: "translate(143.453 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M3.458.154,5.222,0,1.764,39.682,0,39.836Z",
    transform: "translate(115.612 216.746) rotate(-44.8)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 115.62, 241.336)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 1.611,
    height: 31.549,
    transform: "translate(169.469 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M3.458.154,5.222,0,1.764,39.684,0,39.837Z",
    transform: "matrix(0.71, -0.705, 0.705, 0.71, 141.674, 216.786)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 141.675, 241.335)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 1.611,
    height: 31.549,
    transform: "translate(195.74 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M3.458.154,5.222,0,1.764,39.684,0,39.837Z",
    transform: "matrix(0.71, -0.705, 0.705, 0.71, 167.944, 216.783)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 167.946, 241.348)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 1.611,
    height: 31.549,
    transform: "translate(221.999 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M3.458.154,5.222,0,1.764,39.682,0,39.836Z",
    transform: "translate(194.198 216.736) rotate(-44.8)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 194.198, 241.33)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 1.611,
    height: 31.549,
    transform: "translate(248.27 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M3.458.154,5.222,0,1.764,39.684,0,39.837Z",
    transform: "matrix(0.71, -0.705, 0.705, 0.71, 220.475, 216.787)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 220.47, 241.315)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 1.611,
    height: 31.549,
    transform: "translate(274.53 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M3.458.154,5.222,0,1.764,39.682,0,39.836Z",
    transform: "translate(246.723 216.732) rotate(-44.8)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 246.721, 241.351)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 1.611,
    height: 31.549,
    transform: "translate(300.8 212.806)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M3.458.154,5.222,0,1.764,39.684,0,39.837Z",
    transform: "matrix(0.71, -0.705, 0.705, 0.71, 273.006, 216.79)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 272.993, 241.337)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 1.611,
    height: 33.482,
    transform: "translate(327.071 211.847)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M3.458.154,5.222,0,1.764,39.684,0,39.837Z",
    transform: "matrix(0.71, -0.705, 0.705, 0.71, 299.268, 216.811)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M.154,3.458,39.837,0l-.154,1.764L0,5.222Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 299.256, 241.346)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M118.144,211.6H51.21l6.662-8.758L118.1,191.32Zm-63.367-1.878h61.779v-16.2l-57.844,11.06Z",
    transform: "translate(-51.21 33.725)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M69.671,211.2a.739.739,0,0,1-.529-.247l-6.409-7.072-3.187,6.606a.731.731,0,0,1-1.335,0l-2.67-4.742a1.088,1.088,0,0,1-.144-.743.963.963,0,0,1,.363-.628.683.683,0,0,1,.592-.142.793.793,0,0,1,.5.4l1.956,3.481,3.038-6.195a.813.813,0,0,1,.575-.452.673.673,0,0,1,.644.233l6.467,7.14,5.259-9.045a.774.774,0,0,1,.552-.4.688.688,0,0,1,.621.247l8.457,9.224,8.147-12.91a.739.739,0,0,1,.564-.37.683.683,0,0,1,.61.26l11.3,13.006,10.241-16.049a.767.767,0,0,1,.541-.4.692.692,0,0,1,.609.222.985.985,0,0,1,.331.644,1.078,1.078,0,0,1-.17.727l-10.77,16.885a.816.816,0,0,1-.564.37.744.744,0,0,1-.61-.26l-11.3-13.006-8.124,12.883a.758.758,0,0,1-.552.384.729.729,0,0,1-.61-.247l-8.423-9.2-5.27,9.032a.741.741,0,0,1-.552.4Z",
    transform: "translate(-50.581 34.126)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M.131,9.5,128.911,0l-.131,1.963L0,11.466Z",
    transform: "matrix(0.894, -0.449, 0.449, 0.894, 2.348, 228.131)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M6.571.056,8.6,0,2.032,200.751,0,200.807Z",
    transform: "matrix(0.175, -0.985, 0.985, 0.175, 129.86, 178.671)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M16.374.012C25.094-.3,31.906,5.486,31.589,12.945S23.946,26.709,15.226,27.026-.306,21.553.011,14.093,7.654.329,16.374.012Z",
    transform: "translate(233.334 344.238) rotate(-76.65)",
    fill: "#c6c5cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 58.086,
    height: 31.851,
    transform: "translate(248.695 316.061)",
    fill: "#c6c5cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M15.982.056c8.09-.705,14.076,5.281,13.371,13.371A18.148,18.148,0,0,1,13.427,29.353C5.337,30.058-.649,24.072.056,15.982A18.148,18.148,0,0,1,15.982.056Z",
    transform: "translate(283.865 331.982) rotate(-45)",
    fill: "#a1a0a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M277.882,290.578c-5.579,1.767-11.491-.785-14.824-6.4a19.071,19.071,0,0,1-.122-18.78c3.259-5.675,9.138-8.336,14.739-6.672h6.11c-6.818-5.733-16.165-4.451-21.71,2.978a22.388,22.388,0,0,0,.056,26.029c5.578,7.395,14.93,8.619,21.723,2.844Z",
    transform: "translate(-20.483 57.376)",
    fill: "#a1a0a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M313.842,290.578a11.635,11.635,0,0,1-3.521.562c-5.332-.007-10.184-3.669-12.465-9.409a19.024,19.024,0,0,1,1.79-17.447c3.375-4.916,8.824-7.079,14-5.557h6.1c-6.818-5.733-16.165-4.451-21.71,2.978a22.388,22.388,0,0,0,.056,26.029c5.578,7.395,14.93,8.619,21.723,2.844Z",
    transform: "translate(-15.138 57.376)",
    fill: "#a1a0a6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 10.701,
    cy: 12.746,
    rx: 10.701,
    ry: 12.746,
    transform: "translate(293.952 319.241)",
    fill: "#8f8f94"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 52.24,
    height: 121.044,
    transform: "translate(581.599 403.994)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 409.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 409.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 409.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 409.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 409.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 421.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 421.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 421.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 421.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 421.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 434.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 434.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 434.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 434.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 434.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 446.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 446.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 446.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 446.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 446.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 459.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 459.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 459.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 459.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 459.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 471.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 471.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 471.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 471.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 471.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 484.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 484.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 484.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 484.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 484.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 496.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 496.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 496.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 496.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 496.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 6.467,
    height: 8.716,
    transform: "translate(585.512 509.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 6.467,
    height: 8.716,
    transform: "translate(594.867 509.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 6.467,
    height: 8.716,
    transform: "translate(604.486 509.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 6.467,
    height: 8.716,
    transform: "translate(614.094 509.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 6.467,
    height: 8.716,
    transform: "translate(623.714 509.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 72.204,
    height: 167.313,
    transform: "translate(222.763 358.355)",
    fill: "#bcc4e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 365.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 365.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 365.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 365.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 365.523)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 382.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 382.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 382.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 382.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 382.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 400.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 400.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 400.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 400.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 400.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 417.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 417.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 417.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 417.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 417.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 434.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 434.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 434.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 434.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 434.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 452.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 452.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 452.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 452.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 452.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 469.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 469.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 469.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 469.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 469.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 486.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 486.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 486.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 486.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 486.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 8.941,
    height: 12.047,
    transform: "translate(227.854 504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 8.941,
    height: 12.047,
    transform: "translate(241.121 504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 8.941,
    height: 12.047,
    transform: "translate(254.377 504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 8.941,
    height: 12.047,
    transform: "translate(267.644 504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 8.941,
    height: 12.047,
    transform: "translate(280.912 504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 73.907,
    height: 349.537,
    transform: "translate(485.389 176.173)",
    fill: "#e7e8ea"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 9.148,
    height: 12.335,
    transform: "translate(489.651 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 9.148,
    height: 12.335,
    transform: "translate(503.228 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 9.148,
    height: 12.335,
    transform: "translate(516.806 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 9.148,
    height: 12.335,
    transform: "translate(530.383 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 9.148,
    height: 12.335,
    transform: "translate(543.961 213.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 9.148,
    height: 12.335,
    transform: "translate(489.651 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 9.148,
    height: 12.335,
    transform: "translate(503.228 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 9.148,
    height: 12.335,
    transform: "translate(516.806 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 9.148,
    height: 12.335,
    transform: "translate(530.383 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 9.148,
    height: 12.335,
    transform: "translate(543.961 249.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 9.148,
    height: 12.335,
    transform: "translate(489.651 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 9.148,
    height: 12.335,
    transform: "translate(503.228 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 9.148,
    height: 12.335,
    transform: "translate(516.806 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 9.148,
    height: 12.335,
    transform: "translate(530.383 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 9.148,
    height: 12.335,
    transform: "translate(543.961 284.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 9.148,
    height: 12.335,
    transform: "translate(489.651 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 9.148,
    height: 12.335,
    transform: "translate(503.228 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 9.148,
    height: 12.335,
    transform: "translate(516.806 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 9.148,
    height: 12.335,
    transform: "translate(530.383 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 9.148,
    height: 12.335,
    transform: "translate(543.961 320.255)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 9.148,
    height: 12.335,
    transform: "translate(489.651 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 9.148,
    height: 12.335,
    transform: "translate(503.228 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 9.148,
    height: 12.335,
    transform: "translate(516.806 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 9.148,
    height: 12.335,
    transform: "translate(530.383 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 9.148,
    height: 12.335,
    transform: "translate(543.961 355.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 9.148,
    height: 12.335,
    transform: "translate(489.651 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 9.148,
    height: 12.335,
    transform: "translate(503.228 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 9.148,
    height: 12.335,
    transform: "translate(516.806 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 9.148,
    height: 12.335,
    transform: "translate(530.383 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 9.148,
    height: 12.335,
    transform: "translate(543.961 391.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 18.18,
    height: 105.941,
    transform: "translate(494.201 413.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 18.18,
    height: 105.941,
    transform: "translate(530.429 413.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M544.634,422.693v-98.06h8.653v98.06h.552V324.03H544.07v98.663Z",
    transform: "translate(22.071 82.896)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 9.205,
    height: 0.672,
    transform: "translate(566.429 417.822)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(566.705 407.598)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(566.705 407.598)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 9.205,
    height: 0.672,
    transform: "translate(566.429 428.718)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 8.929,
    y2: 10.567,
    transform: "translate(566.705 418.48)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x1: 8.929,
    y2: 10.567,
    transform: "translate(566.705 418.48)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 9.205,
    height: 0.672,
    transform: "translate(566.429 439.6)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x2: 8.929,
    y2: 10.567,
    transform: "translate(566.705 429.375)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 8.929,
    y2: 10.567,
    transform: "translate(566.705 429.375)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 9.205,
    height: 0.672,
    transform: "translate(566.429 450.495)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(566.705 440.271)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(566.705 440.271)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 9.205,
    height: 0.672,
    transform: "translate(566.429 461.391)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(566.705 451.167)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(566.705 451.167)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 9.205,
    height: 0.672,
    transform: "translate(566.429 472.286)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(566.705 462.062)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(566.705 462.062)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 9.205,
    height: 0.672,
    transform: "translate(566.429 483.168)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 8.929,
    y2: 10.567,
    transform: "translate(566.705 472.944)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x1: 8.929,
    y2: 10.567,
    transform: "translate(566.705 472.944)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 9.205,
    height: 0.672,
    transform: "translate(566.429 494.064)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 8.929,
    y2: 10.567,
    transform: "translate(566.705 483.84)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x1: 8.929,
    y2: 10.567,
    transform: "translate(566.705 483.84)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 9.769,
    height: 0.672,
    transform: "translate(566.141 504.96)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 8.929,
    y2: 10.553,
    transform: "translate(566.705 494.735)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 8.929,
    y2: 10.553,
    transform: "translate(566.705 494.735)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 0.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M514.841,444.13V241.937h17.835V444.13h1.162V240.69H513.69V444.13Z",
    transform: "translate(17.541 52.018)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 18.986,
    height: 1.371,
    transform: "translate(531.807 315.17)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M2.479.11,3.74,0,1.261,28.408,0,28.518Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.138, 296.227)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M.11,2.479,28.522,0l-.11,1.261L0,3.74Z",
    transform: "translate(530.146 313.646) rotate(-44.83)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 18.986,
    height: 1.371,
    transform: "translate(531.807 337.633)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M2.479.11,3.74,0,1.261,28.408,0,28.518Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.132, 318.662)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M.11,2.479,28.516,0l-.11,1.261L0,3.74Z",
    transform: "translate(530.145 336.143) rotate(-44.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 18.986,
    height: 1.371,
    transform: "translate(531.807 360.082)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M2.479.11,3.74,0,1.261,28.408,0,28.518Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.145, 341.135)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M.11,2.479,28.516,0l-.11,1.261L0,3.74Z",
    transform: "translate(530.148 358.601) rotate(-44.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 18.986,
    height: 1.371,
    transform: "translate(531.807 382.545)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M2.479.11,3.74,0,1.261,28.408,0,28.518Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.139, 363.583)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M.11,2.479,28.516,0l-.11,1.261L0,3.74Z",
    transform: "translate(530.151 381.058) rotate(-44.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 18.986,
    height: 1.371,
    transform: "translate(531.807 404.994)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M2.479.11,3.74,0,1.261,28.408,0,28.518Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.141, 386.042)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M.11,2.479,28.516,0l-.11,1.261L0,3.74Z",
    transform: "translate(530.147 403.519) rotate(-44.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 18.986,
    height: 1.371,
    transform: "translate(531.807 427.457)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M2.478.11,3.739,0,1.261,28.4,0,28.505Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.156, 408.541)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M.11,2.478,28.5,0l-.11,1.261L0,3.739Z",
    transform: "translate(530.151 425.977) rotate(-44.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 18.986,
    height: 1.371,
    transform: "translate(531.807 449.92)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M2.479.11,3.74,0,1.261,28.408,0,28.518Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.137, 430.963)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M.11,2.479,28.516,0l-.11,1.261L0,3.74Z",
    transform: "translate(530.145 448.424) rotate(-44.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 18.986,
    height: 1.371,
    transform: "translate(531.807 472.369)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M2.479.11,3.74,0,1.261,28.408,0,28.518Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.14, 453.422)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M.11,2.479,28.516,0l-.11,1.261L0,3.74Z",
    transform: "translate(530.148 470.894) rotate(-44.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 20.137,
    height: 1.371,
    transform: "translate(531.231 494.831)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M2.479.11,3.74,0,1.261,28.408,0,28.518Z",
    transform: "matrix(0.705, -0.71, 0.71, 0.705, 530.145, 475.871)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M.11,2.479,28.516,0l-.11,1.261L0,3.74Z",
    transform: "translate(530.151 493.352) rotate(-44.77)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M532.7,250.133H521.84V218.94H532.7Zm-9.712-1.371h8.561v-28.37h-8.561Z",
    transform: "translate(18.764 43.959)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 9.712,
    height: 1.371,
    transform: "translate(541.18 272.136)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    width: 9.597,
    height: 1.453,
    transform: "translate(541.295 282.607)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M399.24,242.074H587.155V263.3H399.24v1.384H588.306v-24H399.24Z",
    transform: "translate(0.313 52.018)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_339",
    "data-name": "Rectangle 339",
    width: 1.151,
    height: 22.614,
    transform: "translate(568.565 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_340",
    "data-name": "Rectangle 340",
    width: 1.151,
    height: 22.614,
    transform: "translate(550.312 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M547.127,264.241l-.817-.973,18.273-21.928.828.973Z",
    transform: "translate(22.391 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M564.583,264.241,546.31,242.313l.817-.973,18.284,21.928Z",
    transform: "translate(22.391 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M531.247,264.241l-.817-.973L548.7,241.34l.817.973Z",
    transform: "translate(20.031 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M548.7,264.241,530.43,242.313l.817-.973,18.273,21.928Z",
    transform: "translate(20.031 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 1.151,
    height: 22.614,
    transform: "translate(531.484 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M514.857,264.241l-.817-.973,18.273-21.928.828.973Z",
    transform: "translate(17.594 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M532.313,264.241,514.04,242.313l.817-.973,18.284,21.928Z",
    transform: "translate(17.594 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 1.151,
    height: 22.614,
    transform: "translate(512.669 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M498.478,264.241l-.828-.973,18.284-21.928.817.973Z",
    transform: "translate(15.158 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M515.934,264.241,497.65,242.313l.828-.973,18.273,21.928Z",
    transform: "translate(15.158 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 1.151,
    height: 22.614,
    transform: "translate(493.841 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M482.087,264.241l-.817-.973,18.272-21.928.828.973Z",
    transform: "translate(12.723 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M499.543,264.241,481.27,242.313l.817-.973,18.284,21.928Z",
    transform: "translate(12.723 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 1.151,
    height: 22.614,
    transform: "translate(475.025 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M465.7,264.241l-.817-.973,18.284-21.928.817.973Z",
    transform: "translate(10.286 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M483.164,264.241,464.88,242.313l.817-.973,18.284,21.928Z",
    transform: "translate(10.286 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 1.151,
    height: 22.614,
    transform: "translate(456.198 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M449.317,264.241l-.817-.973,18.273-21.928.817.973Z",
    transform: "translate(7.851 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M466.773,264.241,448.5,242.313l.817-.973,18.273,21.928Z",
    transform: "translate(7.851 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 1.151,
    height: 22.614,
    transform: "translate(437.371 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M432.927,264.241l-.817-.973,18.273-21.928.828.973Z",
    transform: "translate(5.415 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M450.383,264.241,432.11,242.313l.817-.973,18.284,21.928Z",
    transform: "translate(5.415 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 1.151,
    height: 22.614,
    transform: "translate(418.555 293.407)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M416.548,264.241l-.828-.973L434,241.34l.817.973Z",
    transform: "translate(2.978 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M434,264.241,415.72,242.313l.828-.973,18.273,21.928Z",
    transform: "translate(2.978 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 1.151,
    height: 23.984,
    transform: "translate(399.728 292.708)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M400.157,264.241l-.817-.973,18.273-21.928.828.973Z",
    transform: "translate(0.543 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M417.613,264.241,399.34,242.313l.817-.973,18.284,21.928Z",
    transform: "translate(0.543 52.258)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M610.521,262.128H562.55V247.6l43.161,8.223Zm-46.844-1.37h44.266l-2.819-3.673L563.7,249.149Z",
    transform: "translate(24.573 54.578)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M586.108,261.836H586a.575.575,0,0,1-.4-.274l-5.811-9.224-8.055,9.306a.526.526,0,0,1-.437.192.535.535,0,0,1-.4-.26l-7.721-12.1a.764.764,0,0,1,.1-.946.508.508,0,0,1,.794.123l7.341,11.5,8.055-9.32a.552.552,0,0,1,.437-.178.576.576,0,0,1,.414.26l5.822,9.251,6.064-6.606a.55.55,0,0,1,.449-.178.591.591,0,0,1,.4.288l3.763,6.483,4.6-5.112a.468.468,0,0,1,.472-.178.55.55,0,0,1,.4.329l2.2,4.523,1.4-2.494a.545.545,0,0,1,.513-.318.574.574,0,0,1,.478.387.78.78,0,0,1-.059.685l-1.91,3.385a.5.5,0,0,1-.483.3.567.567,0,0,1-.472-.329l-2.3-4.742-4.6,5.071a.47.47,0,0,1-.437.178.588.588,0,0,1-.414-.288l-3.763-6.483-6.041,6.592a.558.558,0,0,1-.3.178Z",
    transform: "translate(24.649 54.87)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M6.807.093,8.213,0,1.406,92.282,0,92.375Z",
    transform: "translate(547.2 270.324) rotate(-63.35)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M400.079,250.168l-.219-1.439L540.69,218.92l.207,1.439Z",
    transform: "translate(0.478 43.951)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M527.143,374.9l2.98-2.494a.9.9,0,0,1,.541-.206h3.889a1.046,1.046,0,0,1,.944,1.124V376.3a1.248,1.248,0,0,1-.3.815.872.872,0,0,1-.7.308l-6.9-.48a1.01,1.01,0,0,1-.824-.834,1.239,1.239,0,0,1,.375-1.208Z",
    transform: "translate(19.495 100.744)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 11.863,
    height: 10.553,
    transform: "translate(555.295 504.219)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M543.65,395.02v9.8h32.99V395.76Z",
    transform: "translate(21.977 109.199)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M554.6,406.52l6.156-9.84h25.084l2.854,4.92v3.056a1.734,1.734,0,0,1-1.565,1.864Z",
    transform: "translate(23.602 109.814)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M589.989,403.729v.11a3.28,3.28,0,0,1-2.946,3.522H540.694a3.27,3.27,0,0,1-2.934-3.522v-.548a3.169,3.169,0,0,1,2.911-3.07H587.02a3.169,3.169,0,0,1,2.911,3.07,2.669,2.669,0,0,1,.057.439Z",
    transform: "translate(21.073 111.126)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M545.47,406.115v3.18H518.452c-1.907,0-3.452-1.841-3.452-4.111v-5.194c0-2.755,1.875-4.989,4.188-4.989h16.984a8.4,8.4,0,0,1,5.639,2.262,11.007,11.007,0,0,1,3.049,4.851,12.752,12.752,0,0,1,.587,3.07C545.458,405.526,545.47,405.813,545.47,406.115Z",
    transform: "translate(17.722 109.192)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M593.418,402.91v.11a3.28,3.28,0,0,1-2.946,3.522h-72.02c-1.907,0-3.452-1.841-3.452-4.111h78.441a2.709,2.709,0,0,1-.023.48Z",
    transform: "translate(17.654 111.945)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M544.146,399.781H515v-.37a5.7,5.7,0,0,1,.679-2.741h26.132a11.112,11.112,0,0,1,2.336,3.111Z",
    transform: "translate(17.724 109.811)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M572.231,406.2c0,4.776-3.251,8.648-7.261,8.648s-7.261-3.872-7.261-8.648,3.251-8.648,7.261-8.648,7.261,3.872,7.261,8.648Z",
    transform: "translate(24.093 110.137)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M568.041,405c0,2.339-1.592,4.235-3.556,4.235s-3.556-1.9-3.556-4.235,1.592-4.235,3.556-4.235A3.281,3.281,0,0,1,567,402.006a4.665,4.665,0,0,1,1.038,3Z",
    transform: "translate(24.582 111.33)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M566.167,404.471a1.928,1.928,0,1,1-1.9-2.261,1.746,1.746,0,0,1,1.346.658A2.484,2.484,0,0,1,566.167,404.471Z",
    transform: "translate(24.8 111.863)",
    fill: "#c28101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M585.261,406.2c0,4.776-3.251,8.648-7.261,8.648s-7.261-3.872-7.261-8.648,3.251-8.648,7.261-8.648,7.254,3.875,7.261,8.648Z",
    transform: "translate(25.807 110.137)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M581.058,405c-.006,2.329-1.6,4.213-3.552,4.207s-3.539-1.9-3.536-4.226,1.588-4.217,3.544-4.217a3.284,3.284,0,0,1,2.51,1.241A4.665,4.665,0,0,1,581.058,405Z",
    transform: "translate(26.293 111.33)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M579.2,404.471a1.928,1.928,0,1,1-1.9-2.261,1.747,1.747,0,0,1,1.346.658A2.484,2.484,0,0,1,579.2,404.471Z",
    transform: "translate(26.509 111.863)",
    fill: "#c28101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M589.995,405.083a1.4,1.4,0,0,1-1.151-.754l-3.084-5.482H560.791l-3.452,5.482a1.293,1.293,0,0,1-2.014.343,1.937,1.937,0,0,1-.288-2.4l3.889-6.208a1.376,1.376,0,0,1,1.151-.685h26.385a1.444,1.444,0,0,1,1.151.754l3.452,6.208a1.941,1.941,0,0,1-.391,2.385,1.36,1.36,0,0,1-.679.356Z",
    transform: "translate(23.621 109.333)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M542.488,380.119v18.475c-.006,3.083-2.106,5.578-4.695,5.578H518.382c-2.441,0-4.474-2.228-4.672-5.126v-5.427a6.347,6.347,0,0,1,.506-2.508l.3-.713,4.994-11.786.161-.37a4.708,4.708,0,0,1,3.993-3.056l8.918-.411,5.063-.233a4.31,4.31,0,0,1,3.413,1.569,6.155,6.155,0,0,1,1.432,4.009Z",
    transform: "translate(17.533 101.61)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M534.272,382.618c0,9.594-6.9,17.323-15.477,17.323a14.022,14.022,0,0,1-5.086-.959v-5.427a6.348,6.348,0,0,1,.506-2.508l.3-.713,4.994-11.786.161-.37a4.708,4.708,0,0,1,3.993-3.056l8.918-.411a18.885,18.885,0,0,1,1.691,7.908Z",
    transform: "translate(17.543 101.674)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M532.835,381.8v3.632c-.006,2.364-1.617,4.276-3.6,4.276h-13.29a3.177,3.177,0,0,1-1.553-.411l.472-1.1,4-9.443.518-1.247h9.85C531.223,377.51,532.835,379.431,532.835,381.8Z",
    transform: "translate(17.647 102.712)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M530.005,380.72v4.742a1.771,1.771,0,0,1-1.714,1.836H517.1a2.52,2.52,0,0,1-.725-.082l3.889-8.346h7.986a1.634,1.634,0,0,1,1.369.768A1.825,1.825,0,0,1,530.005,380.72Z",
    transform: "translate(17.948 103.216)",
    fill: "#0086fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M525.482,378.87l-5.3,8.429h-2.2l5.4-8.429Z",
    transform: "translate(18.195 103.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M528.841,379.645l-4.821,7.634H521.81l5.4-8.429h.265a1.644,1.644,0,0,1,1.369.795Z",
    transform: "translate(18.765 103.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 7.203,
    height: 1.535,
    transform: "translate(543.274 494.283)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 2.831,
    height: 1.727,
    transform: "translate(553.572 494.406)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 2.831,
    height: 1.987,
    transform: "translate(553.572 481.359)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 2.831,
    height: 1.727,
    transform: "translate(553.572 491.844)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 2.831,
    height: 1.727,
    transform: "translate(553.572 489.281)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 2.831,
    height: 1.727,
    transform: "translate(553.572 486.732)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 2.831,
    height: 1.727,
    transform: "translate(553.572 484.169)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 21.138,
    height: 1.343,
    transform: "translate(535.273 499.135)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_359",
    "data-name": "Rectangle 359",
    width: 21.138,
    height: 0.672,
    transform: "translate(535.273 501.286)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M535.021,406.2c0,4.776-3.251,8.648-7.261,8.648s-7.261-3.872-7.261-8.648,3.251-8.648,7.261-8.648,7.254,3.875,7.261,8.648Z",
    transform: "translate(18.56 110.137)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M530.821,405a4.309,4.309,0,0,1-2.2,3.914,3.153,3.153,0,0,1-3.876-.924,4.843,4.843,0,0,1-.763-4.62,3.6,3.6,0,0,1,3.293-2.6,3.284,3.284,0,0,1,2.51,1.241A4.665,4.665,0,0,1,530.821,405Z",
    transform: "translate(19.047 111.33)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M528.946,404.519a1.9,1.9,0,1,1-3.786,0,2.412,2.412,0,0,1,.9-2.1,1.643,1.643,0,0,1,1.983,0A2.412,2.412,0,0,1,528.946,404.519Z",
    transform: "translate(19.266 111.816)",
    fill: "#c28101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M536.784,408.823a1.329,1.329,0,0,1-1.024-.5,1.89,1.89,0,0,1-.425-1.216,9.089,9.089,0,0,0-3.519-7.726,6.236,6.236,0,0,0-7.38,0,9.089,9.089,0,0,0-3.519,7.726,1.46,1.46,0,1,1-2.877,0c0-6.638,4.518-12.019,10.091-12.019s10.091,5.381,10.091,12.019A1.594,1.594,0,0,1,536.784,408.823Z",
    transform: "translate(18.188 109.225)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M365.144,251.77h0c-21.405,0-39.317,19.326-41.425,44.688l82.849-.009C404.451,271.09,386.54,251.772,365.144,251.77Z",
    transform: "translate(-10.752 56.123)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M323.757,284.37q-.208,2.445-.207,4.906V460.015h24.6V426.04H379.76v33.975H406.8V289.345c0-1.658-.081-3.289-.207-4.906ZM343.94,443.2H329.533V426.04H343.94Zm0-25.711H329.533V400.357H343.94Zm0-25.711H329.533V374.619H343.94Zm0-25.711H329.533V348.908H343.94Zm18.629,51.422H348.151V400.357h14.418Zm0-25.711H348.151V374.619h14.418Zm0-25.711H348.151V348.908h14.418Zm18.618,51.422H366.78V400.357h14.406Zm0-25.711H366.78V374.619h14.406Zm0-25.711H366.78V348.908h14.406ZM399.816,443.2H385.4V426.04h14.418Zm0-25.711H385.4V400.357h14.418Zm0-25.711H385.4V374.619h14.418Zm0-25.711H385.4V348.908h14.418Z",
    transform: "translate(-10.777 68.202)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 14.418,
    height: 17.173,
    transform: "translate(318.803 417.109)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 14.418,
    height: 17.173,
    transform: "translate(337.388 417.109)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_362",
    "data-name": "Rectangle 362",
    width: 14.418,
    height: 17.173,
    transform: "translate(355.985 417.109)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_363",
    "data-name": "Rectangle 363",
    width: 14.418,
    height: 17.173,
    transform: "translate(374.571 417.109)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_364",
    "data-name": "Rectangle 364",
    width: 14.418,
    height: 17.173,
    transform: "translate(318.803 442.82)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_365",
    "data-name": "Rectangle 365",
    width: 14.418,
    height: 17.173,
    transform: "translate(337.388 442.82)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_366",
    "data-name": "Rectangle 366",
    width: 14.418,
    height: 17.173,
    transform: "translate(355.985 442.82)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    width: 14.418,
    height: 17.173,
    transform: "translate(374.571 442.82)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 14.418,
    height: 17.173,
    transform: "translate(318.803 468.531)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    width: 14.418,
    height: 17.173,
    transform: "translate(337.388 468.531)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    width: 14.418,
    height: 17.173,
    transform: "translate(355.985 468.531)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    width: 14.418,
    height: 17.173,
    transform: "translate(374.571 468.531)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 14.418,
    height: 17.173,
    transform: "translate(318.803 494.242)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 31.609,
    height: 33.989,
    transform: "translate(337.374 494.242)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_374",
    "data-name": "Rectangle 374",
    width: 14.418,
    height: 17.173,
    transform: "translate(374.571 494.242)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_375",
    "data-name": "Rectangle 375",
    width: 23.289,
    height: 111.067,
    transform: "translate(611.896 418.137)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_376",
    "data-name": "Rectangle 376",
    width: 23.289,
    height: 6.017,
    transform: "translate(611.896 425.099)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_377",
    "data-name": "Rectangle 377",
    width: 23.289,
    height: 10.114,
    transform: "translate(611.896 439.065)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_378",
    "data-name": "Rectangle 378",
    width: 23.289,
    height: 6.03,
    transform: "translate(611.896 458.485)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_379",
    "data-name": "Rectangle 379",
    width: 23.289,
    height: 10.128,
    transform: "translate(611.896 472.437)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_380",
    "data-name": "Rectangle 380",
    width: 23.289,
    height: 6.03,
    transform: "translate(611.896 491.871)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_381",
    "data-name": "Rectangle 381",
    width: 23.289,
    height: 10.128,
    transform: "translate(611.896 505.837)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 3.015,
    height: 111.067,
    transform: "translate(622.034 418.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_383",
    "data-name": "Rectangle 383",
    width: 23.289,
    height: 111.067,
    transform: "translate(611.896 314.883)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_384",
    "data-name": "Rectangle 384",
    width: 23.289,
    height: 6.017,
    transform: "translate(611.896 321.845)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_385",
    "data-name": "Rectangle 385",
    width: 23.289,
    height: 10.114,
    transform: "translate(611.896 335.797)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_386",
    "data-name": "Rectangle 386",
    width: 23.289,
    height: 6.03,
    transform: "translate(611.896 355.217)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_387",
    "data-name": "Rectangle 387",
    width: 23.289,
    height: 10.128,
    transform: "translate(611.896 369.182)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    width: 23.289,
    height: 6.03,
    transform: "translate(611.896 388.616)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    width: 23.289,
    height: 10.128,
    transform: "translate(611.896 402.568)",
    fill: "#cccbd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    width: 3.015,
    height: 111.067,
    transform: "translate(622.034 314.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y2: 45.529,
    transform: "translate(464.24 333.22)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 1.79
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    y2: 45.529,
    transform: "translate(458.152 333.22)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 1.79
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y2: 45.529,
    transform: "translate(452.064 333.22)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 1.79
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y2: 45.529,
    transform: "translate(445.987 333.22)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 1.79
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    y2: 45.529,
    transform: "translate(439.899 333.22)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 1.79
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    y2: 45.529,
    transform: "translate(433.811 333.22)",
    fill: "none",
    stroke: "#9a999e",
    strokeWidth: 1.79
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    width: 48.627,
    height: 154.649,
    transform: "translate(423.767 373.568)",
    fill: "#b1b1b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    width: 8.423,
    height: 12.047,
    transform: "translate(427.301 378.036)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    width: 8.423,
    height: 12.047,
    transform: "translate(438.156 378.036)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    width: 8.423,
    height: 12.047,
    transform: "translate(449.023 378.036)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 8.423,
    height: 12.047,
    transform: "translate(459.878 378.036)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 8.423,
    height: 12.047,
    transform: "translate(427.301 396.086)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 8.423,
    height: 12.047,
    transform: "translate(438.156 396.086)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_398",
    "data-name": "Rectangle 398",
    width: 8.423,
    height: 12.047,
    transform: "translate(449.023 396.086)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_399",
    "data-name": "Rectangle 399",
    width: 8.423,
    height: 12.047,
    transform: "translate(459.878 396.086)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 8.423,
    height: 12.047,
    transform: "translate(427.301 414.135)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_401",
    "data-name": "Rectangle 401",
    width: 8.423,
    height: 12.047,
    transform: "translate(438.156 414.135)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_402",
    "data-name": "Rectangle 402",
    width: 8.423,
    height: 12.047,
    transform: "translate(449.023 414.135)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    width: 8.423,
    height: 12.047,
    transform: "translate(459.878 414.135)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_404",
    "data-name": "Rectangle 404",
    width: 8.423,
    height: 12.047,
    transform: "translate(427.301 432.171)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    width: 8.423,
    height: 12.047,
    transform: "translate(438.156 432.171)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 8.423,
    height: 12.047,
    transform: "translate(449.023 432.171)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    width: 8.423,
    height: 12.047,
    transform: "translate(459.878 432.171)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    width: 8.423,
    height: 12.047,
    transform: "translate(427.301 450.221)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    width: 8.423,
    height: 12.047,
    transform: "translate(438.156 450.221)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    width: 8.423,
    height: 12.047,
    transform: "translate(449.023 450.221)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    width: 8.423,
    height: 12.047,
    transform: "translate(459.878 450.221)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    width: 8.423,
    height: 12.047,
    transform: "translate(427.301 468.271)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_413",
    "data-name": "Rectangle 413",
    width: 8.423,
    height: 12.047,
    transform: "translate(438.156 468.271)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 8.423,
    height: 12.047,
    transform: "translate(449.023 468.271)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 8.423,
    height: 12.047,
    transform: "translate(459.878 468.271)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_416",
    "data-name": "Rectangle 416",
    width: 8.423,
    height: 12.047,
    transform: "translate(427.301 486.32)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    width: 8.423,
    height: 12.047,
    transform: "translate(438.156 486.32)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_418",
    "data-name": "Rectangle 418",
    width: 8.423,
    height: 12.047,
    transform: "translate(449.023 486.32)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_419",
    "data-name": "Rectangle 419",
    width: 8.423,
    height: 12.047,
    transform: "translate(459.878 486.32)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_420",
    "data-name": "Rectangle 420",
    width: 8.423,
    height: 12.047,
    transform: "translate(427.301 504.37)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_421",
    "data-name": "Rectangle 421",
    width: 18.468,
    height: 23.861,
    transform: "translate(438.145 504.37)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_422",
    "data-name": "Rectangle 422",
    width: 8.423,
    height: 12.047,
    transform: "translate(459.878 504.37)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M317.383,425H181.8c.944-1.371,1.772-2.494,2.232-3.193a43.1,43.1,0,0,1,10.091-11.129l.38-.26c5.868-4.112,12.761-5.962,18.411-10.389l.541-.411c4.695-3.851,8.354-9.237,12.335-14.157a9.825,9.825,0,0,1,.633-.795l.656-.809c4.257-4.975,9.378-9.4,15.269-10.018,4.787-.507,9.493,1.576,13.739,4.235a74.571,74.571,0,0,1,7.215,5.3c.99.822,1.979,1.686,2.946,2.535,2.888,2.563,5.7,5.263,8.526,7.935,1.669,1.576,3.348,3.138,5.051,4.646s3.164,2.741,4.787,4.112c1.208.959,2.428,1.864,3.694,2.741,5.753,4.112,11.909,7.689,17.858,11.553a105.743,105.743,0,0,1,11.219,8.1Z",
    transform: "translate(-31.847 101.324)",
    fill: "#bbbac2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M286.7,405.294a64.17,64.17,0,0,1-11.207,5.249c-10.356,3.495-21.241,3.015-31.839,4.92-10.195,1.864-20.413,5.962-30.608,4.112-6.306-1.151-12.151-4.55-17.893-7.894-.736-.425-1.507-.836-2.3-1.261,5.868-4.112,12.761-5.962,18.411-10.389l.541-.411c4.695-3.851,8.354-9.237,12.335-14.157a9.823,9.823,0,0,1,.633-.795l.656-.809c4.257-4.975,9.378-9.4,15.269-10.018,4.787-.507,9.493,1.576,13.739,4.235a74.562,74.562,0,0,1,7.215,5.3c.99.822,1.979,1.686,2.946,2.535,2.888,2.563,5.7,5.263,8.526,7.935,1.668,1.576,3.348,3.138,5.051,4.646s3.164,2.741,4.787,4.112C284.213,403.512,285.432,404.417,286.7,405.294Z",
    transform: "translate(-30.187 101.324)",
    fill: "#a1a0a6",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M275.69,398.5c-1.036.068-2.071.178-3.107.343-6.214.973-12.151,3.563-18.284,5.085a53.891,53.891,0,0,1-26.546-.137c-4.775-1.233-9.412-3.138-14.234-3.947a18.4,18.4,0,0,0-4.2-.219c4.695-3.851,8.354-9.237,12.335-14.157a9.823,9.823,0,0,1,.633-.795l.656-.809c4.257-4.975,9.378-9.4,15.269-10.018,4.787-.507,9.493,1.576,13.739,4.235a74.561,74.561,0,0,1,7.215,5.3c.99.822,1.979,1.686,2.946,2.535,2.888,2.563,5.7,5.263,8.526,7.935C272.353,395.426,274.033,396.989,275.69,398.5Z",
    transform: "translate(-27.728 101.324)",
    fill: "#abaab0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M241.1,425.515H105.51c.944-1.37,1.772-2.494,2.232-3.193a43.09,43.09,0,0,1,10.091-11.129l.391-.26c5.857-4.112,12.749-5.962,18.411-10.388.184-.137.368-.274.541-.425,4.706-3.837,8.354-9.224,12.335-14.157.207-.274.426-.534.633-.795l.656-.795c4.257-4.989,9.378-9.415,15.269-10.032,4.787-.493,9.493,1.576,13.75,4.249a72.867,72.867,0,0,1,7.215,5.3c.978.822,1.968,1.672,2.946,2.535,2.877,2.549,5.684,5.263,8.515,7.935,1.68,1.576,3.348,3.125,5.063,4.646s3.164,2.741,4.787,4.043c1.151.959,2.428,1.878,3.682,2.741,5.753,4.112,11.921,7.675,17.858,11.54a104.323,104.323,0,0,1,11.219,8.182Z",
    transform: "translate(-43.029 101.51)",
    fill: "#bebdc4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M210.408,405.807a64.371,64.371,0,0,1-11.207,5.249c-10.356,3.481-21.241,3-31.839,4.92-10.195,1.85-20.4,5.962-30.6,4.112-6.317-1.165-12.163-4.55-17.9-7.894-.736-.425-1.507-.836-2.3-1.261,5.857-4.112,12.749-5.962,18.411-10.388.184-.137.368-.274.541-.425,4.706-3.837,8.354-9.224,12.335-14.157.207-.274.426-.534.633-.795l.656-.795c4.257-4.989,9.378-9.415,15.269-10.032,4.787-.493,9.493,1.576,13.75,4.249a72.868,72.868,0,0,1,7.215,5.3c.978.822,1.968,1.672,2.946,2.535,2.877,2.549,5.684,5.263,8.515,7.935,1.68,1.576,3.348,3.125,5.063,4.646s3.164,2.741,4.787,4.043C207.969,404.053,209.119,404.93,210.408,405.807Z",
    transform: "translate(-41.364 101.51)",
    fill: "#bebdc4",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M199.452,399.009a19.948,19.948,0,0,0-3.118.343c-6.214.973-12.151,3.563-18.284,5.085a53.892,53.892,0,0,1-26.546-.151c-4.775-1.233-9.412-3.125-14.234-3.947a20.105,20.105,0,0,0-4.2-.219c4.706-3.837,8.354-9.224,12.335-14.157.207-.274.426-.534.633-.795l.656-.795c4.257-4.989,9.378-9.415,15.269-10.032,4.787-.493,9.493,1.576,13.75,4.249a72.852,72.852,0,0,1,7.215,5.3c.978.822,1.968,1.672,2.946,2.536,2.877,2.549,5.684,5.263,8.515,7.935C196.069,395.939,197.737,397.488,199.452,399.009Z",
    transform: "translate(-38.877 101.51)",
    fill: "#bebdc4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_423",
    "data-name": "Rectangle 423",
    width: 23.002,
    height: 9.744,
    transform: "translate(217.503 526.161) rotate(180)",
    fill: "#8b8a8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 9.125,
    height: 3.988,
    rx: 0.21,
    transform: "translate(216.268 523.283) rotate(180)",
    fill: "#d7d6de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 10.275,
    height: 3.988,
    rx: 0.28,
    transform: "translate(206.011 523.283) rotate(180)",
    fill: "#d7d6de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 23.002,
    height: 9.744,
    transform: "translate(217.503 516.581) rotate(180)",
    fill: "#abaab0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 9.125,
    height: 3.988,
    rx: 0.21,
    transform: "translate(216.268 513.703) rotate(180)",
    fill: "#d7d6de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 10.275,
    height: 3.988,
    rx: 0.28,
    transform: "translate(206.011 513.703) rotate(180)",
    fill: "#d7d6de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 23.002,
    height: 9.744,
    transform: "translate(217.503 507.399) rotate(180)",
    fill: "#c8c7cf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 9.125,
    height: 3.988,
    rx: 0.21,
    transform: "translate(216.268 504.535) rotate(180)",
    fill: "#abaab0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_431",
    "data-name": "Rectangle 431",
    width: 10.275,
    height: 3.988,
    rx: 0.28,
    transform: "translate(206.011 504.535) rotate(180)",
    fill: "#abaab0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 23.002,
    height: 9.744,
    transform: "translate(217.503 497.819) rotate(180)",
    fill: "#8b8a8f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 9.125,
    height: 3.988,
    rx: 0.21,
    transform: "translate(216.268 494.955) rotate(180)",
    fill: "#d7d6de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 10.275,
    height: 3.988,
    rx: 0.28,
    transform: "translate(206.011 494.955) rotate(180)",
    fill: "#d7d6de"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_435",
    "data-name": "Rectangle 435",
    width: 79.845,
    height: 42.897,
    transform: "translate(109.566 483.1)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M159.605,379.61,154.864,391.6l-7.479,18.9-.955,2.426V394.672l1.22-3.07,4.729-11.992Z",
    transform: "translate(-36.864 103.49)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M174.645,379.61l-16.961,42.9H150.47l16.949-42.9Z",
    transform: "translate(-36.255 103.49)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M188.245,379.61l-16.961,42.9H164.07l16.961-42.9Z",
    transform: "translate(-34.434 103.49)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M201.845,379.61l-16.949,42.9H177.67l16.961-42.9Z",
    transform: "translate(-32.412 103.49)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M215.445,379.61l-16.949,42.9H191.27l16.961-42.9Z",
    transform: "translate(-30.391 103.49)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M217.471,387.65v18.255l-.633,1.617L212.1,419.528H204.86l4.752-12.006,7.479-18.9Z",
    transform: "translate(-28.366 106.469)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 79.845,
    height: 23.724,
    transform: "translate(109.566 492.68)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("text", {
    id: "under_construction",
    "data-name": "under construction",
    transform: "translate(112.367 504.422)",
    fill: "#646469",
    fontSize: 8,
    fontFamily: "Bebas Neue"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: "0.009em"
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "0.399em"
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "er construction")), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M726.123,422.834H106.8c-2.93,0-5.305-2.835-5.305-6.332s2.375-6.332,5.305-6.332H726.123c2.93,0,5.305,2.835,5.305,6.332S729.054,422.834,726.123,422.834Z",
    transform: "translate(-43.635 114.813)",
    fill: "#d7d6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M8.129.017,10.431,0c4.386-.032,7.916,4.175,7.884,9.4l-.107,17.47c-.032,5.229-3.619,9.494-8.011,9.526l-2.3.017C3.5,36.441-.032,32.228,0,27L.107,9.543C.139,4.314,3.725.049,8.118.017Z",
    transform: "translate(591.986 409.768) rotate(-2.18)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M577.716,363.319h0a2.289,2.289,0,0,1-1.809-.792,3.26,3.26,0,0,1-.8-2.086l-1.024-32.18a3.34,3.34,0,0,1,.665-2.154,2.359,2.359,0,0,1,1.752-.957h0a2.747,2.747,0,0,1,2.612,2.878l1.024,32.18a3.34,3.34,0,0,1-.665,2.154A2.359,2.359,0,0,1,577.716,363.319Z",
    transform: "translate(26.309 83.311)",
    fill: "#f1592a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M577.41,319.97l6.881,177.948h15.58L615.29,352.246l15.822,145.672h15.649l4.315-177.948Z",
    transform: "translate(26.812 81.392)",
    fill: "#195c92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M585.517,449.81l-16.247,18.1H601.1v-18.1Z",
    transform: "translate(25.585 129.5)",
    fill: "#f28705"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M639.72,449.81l16.259,18.1H624.14v-18.1Z",
    transform: "translate(33.852 129.5)",
    fill: "#f28705"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M649.723,238.862v.206l-3.659,47.461v.85l-2.934,37.977-29.492-1.836-29.572,1.836-1.151-15.569-.863-11.156-.61-7.867-.069-.877-.242-3.152h0l-.069-.987h0l-.472-6.126-3.141-40.745h0l13.889-9.32,6.03-4.112,1.737-1.165,1.415-.959,1.611-1.083,1.266-.768,2.6-1.741h15.131l2.635,1.741,1.07.713h.092l2.163,1.453.23.151,8.964,6.017Z",
    transform: "translate(26.818 44.252)",
    fill: "#ffd12d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 20.367,
    height: 31.303,
    transform: "translate(630.215 243.999)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M624.256,233.294h-.564a22.969,22.969,0,0,1-3.326-.315,28.6,28.6,0,0,1-6.777-1.754,24.01,24.01,0,0,1-5.845-3.289,23.3,23.3,0,0,1-4.361-4.345,20.15,20.15,0,0,1-3.383-6.3h0l4.039-2.549,7.5-4.769,1.22-.767h7.606v16.172l1.07.713h.092l2.163,1.453.23.151h0Z",
    transform: "translate(30.215 40.35)",
    fill: "#634518",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M632.365,228.068,624.9,256.849l-.3,1.179-12.657,18.3-.575.822-10.16-7.606-2.923-8.223L592,243.72l3.164-18.886,1.737-1.165,1.415-.959,1.611-1.083s.426.452,1.151,1.1l.138.11c2.3,1.946,7.548,5.482,13.589,3.81a15.575,15.575,0,0,0,6.777-4.043q.529-.507,1.07-1.11l2.3,1.535.23.151.276.178Z",
    transform: "translate(29.01 44.904)",
    fill: "#ffd12d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M588.631,272.021s-7.353,22.12-9.125,27.26-8.354,11.362-8.354,11.362H536c5.4-2.864,16.42-9,20.712-13.486,5.822-6.03,14.441-37.717,14.441-37.717Z",
    transform: "translate(20.811 58.965)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M689.481,310.643c-5.4-2.851-16.42-9-20.712-13.486-5.822-6.03-14.441-37.717-14.441-37.717L636.85,272.021s7.341,22.12,9.125,27.26,8.308,11.362,8.308,11.362Z",
    transform: "translate(35.767 58.965)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M580.093,233.69,559.6,267.336l24.176,14.226,4.971-40.54Z",
    transform: "translate(24.353 49.424)",
    fill: "#ffd12d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M641.263,233.69l20.5,33.646-24.187,14.226-4.971-40.54Z",
    transform: "translate(35.128 49.424)",
    fill: "#ffd12d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M646.1,263.43l-.84,11.142H580.992l-.851-11.142Z",
    transform: "translate(27.223 60.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M644.467,277.3l-.829,11.156H582.262L581.41,277.3Z",
    transform: "translate(27.414 65.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M592.084,202.219c.253,3.276,1.933,5.77,3.751,5.564s1.277-2.645,1.024-5.921-.115-6.113-1.933-5.921S591.842,198.958,592.084,202.219Z",
    transform: "translate(29.018 35.434)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M625.007,207.775a34.119,34.119,0,0,1-.9,8.922c-1.611,4.591-5.328,7.565-6.973,9.964a4.923,4.923,0,0,0-.357.548c-1.415,2.494-5.328,3.3-6.8,3.221s-5.385-.726-6.8-3.221-5.592-5.564-7.33-10.512-.449-22.764-.449-22.764l10.183-2.3,4.4-1,14.579,3.248s.069.973.161,2.535C624.926,199.168,625.064,203.622,625.007,207.775Z",
    transform: "translate(29.453 33.469)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M592.356,190.13s5.005,14.706,18.641,12.4c0,0-3.774-5.975-2.808-12.664l-16.639.26",
    transform: "translate(28.942 33.188)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M597.469,193.618l-.633,14.39-2.8-14.939Z",
    transform: "translate(29.317 34.374)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M600.05,191.761s8.158,12.8,21.794,10.5a47.82,47.82,0,0,1-.46-13.979L602.4,189.856",
    transform: "translate(30.223 32.599)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M617.7,193.392l.737,14.939,3-9.347-.15-6.784Z",
    transform: "translate(32.882 34.051)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M625.495,202.219c-.253,3.276-1.933,5.77-3.751,5.564s-2.2-2.645-1.945-5.921,1.047-6.113,2.865-5.921S625.794,198.958,625.495,202.219Z",
    transform: "translate(33.187 35.434)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M632.745,197.143c0,1.3-.074,2.592-.207,3.879H589.676c-.129-1.287-.195-2.582-.2-3.879a33.24,33.24,0,0,1,7.756-22.079l.345-.37a21.906,21.906,0,0,1,4.8-3.879,17.177,17.177,0,0,1,8.734-2.426,18.568,18.568,0,0,1,13.486,6.318l.345.37A31.69,31.69,0,0,1,632.354,192a37.836,37.836,0,0,1,.391,5.139Z",
    transform: "translate(28.63 25.229)",
    fill: "#f28705"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M621.117,173.374c-.207.356-.4.74-.587,1.124l-.242.466-.207.493-.4.959c-.242.672-.495,1.371-.713,2s-.391,1.371-.575,2.056l-.472,2.1c-.23,1.371-.483,2.823-.6,4.262l-.115,1.083v1.069l-.1,2.152v4.317c.069,1.371.15,2.59.23,3.865H615.11v-3.851l.127-2.234A16.2,16.2,0,0,1,615.4,191l.242-2.22.058-.548.092-.548.184-1.1q.357-2.2.909-4.345l.621-2.124c.23-.7.483-1.371.736-2.056s.564-1.371.852-2l.495-.973.242-.48.265-.452c.23-.4.472-.781.725-1.165Z",
    transform: "translate(32.492 26.934)",
    fill: "#ca7e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M600.313,193.3v-2.165l-.092-2.152v-1.069l-.1-1.083c-.115-1.439-.38-2.837-.61-4.262l-.46-2.1c-.184-.685-.391-1.371-.587-2.056s-.46-1.371-.7-2l-.414-.959-.207-.493-.23-.466c-.184-.384-.38-.767-.587-1.124a3.373,3.373,0,0,1,.345-.384c.253.384.483.768.713,1.165l.276.452.242.48.483.973c.3.658.587,1.371.863,2s.495,1.371.736,2.056l.61,2.124q.552,2.142.909,4.345l.184,1.1.092.548.069.548.242,2.22c.092.74.1,1.494.161,2.234l.115,2.234v3.851H600.14c.092-1.275.161-2.563.242-3.865Z",
    transform: "translate(29.661 26.934)",
    fill: "#ca7e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M589.65,192.2s17.179,5.372,42.862,0Z",
    transform: "translate(28.656 34.051)",
    fill: "#ca7e35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M632.745,196.488q-.007,1.945-.207,3.879H589.676c-.129-1.287-.195-2.582-.2-3.879a33.24,33.24,0,0,1,7.756-22.079l.345-.37a21.905,21.905,0,0,1,4.8-3.879c7.489,11.2,18.167,18.731,30.009,21.174a37.837,37.837,0,0,1,.357,5.153Z",
    transform: "translate(28.63 25.885)",
    fill: "#f79c0d",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M632.512,193.221H589.65S606.622,184.724,632.512,193.221Z",
    transform: "translate(28.656 33.03)",
    fill: "#fcb501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M598.662,222.38v65.607H589.48V228.561l6.029-4.057,1.737-1.165Z",
    transform: "translate(28.63 45.233)",
    fill: "#f28705"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M629.784,228.767v59.138H620.59V222.6l.23.151Z",
    transform: "translate(33.317 45.315)",
    fill: "#f28705"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M702.578,343.37a455.708,455.708,0,0,1-163.59,0q-9.666-45.652-19.308-91.29a559.545,559.545,0,0,0,202.206,0Q712.209,297.718,702.578,343.37Z",
    transform: "translate(18.114 56.238)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M528.683,285.77l-4.6,8.442,3.843,8.854c1.7,3.906,5.333,6.05,8.975,5.3,5.592-1.151,12.807-3.262,11.955-6.5-1.381-5.208-5.051-18.584-9.205-17.227a71.259,71.259,0,0,0-10.172,4.879Z",
    transform: "translate(19.079 68.268)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M689.65,285.77l4.6,8.442-4.039,9.292a6.477,6.477,0,0,1-6.49,4.235c-5.834-.658-15.2-2.261-14.245-5.866,1.381-5.208,5.051-18.584,9.205-17.227a71.261,71.261,0,0,1,10.172,4.879Z",
    transform: "translate(40.673 68.268)",
    fill: "#faad3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 34.474,
    height: 26.711,
    transform: "translate(625.106 421.139)",
    fill: "#195c92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M287.934,404.627c-.006,6.44-4.393,11.654-9.8,11.649s-9.787-5.228-9.785-11.668,4.386-11.659,9.792-11.659a9.072,9.072,0,0,1,6.928,3.421A12.885,12.885,0,0,1,287.934,404.627Z",
    transform: "translate(-18.93 108.432)",
    fill: "#97969c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_439",
    "data-name": "Rectangle 439",
    width: 41.044,
    height: 23.34,
    transform: "translate(258.147 501.382)",
    fill: "#97969c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M322.7,404.627c-.006,6.44-4.393,11.654-9.8,11.649s-9.787-5.228-9.785-11.668,4.386-11.659,9.792-11.659a9.073,9.073,0,0,1,6.928,3.421A12.886,12.886,0,0,1,322.7,404.627Z",
    transform: "translate(-13.761 108.432)",
    fill: "#a1a0a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M320.492,403.993c0,5.155-3.508,9.333-7.836,9.333s-7.836-4.179-7.836-9.333,3.508-9.333,7.836-9.333S320.492,398.839,320.492,403.993Z",
    transform: "translate(-13.506 109.066)",
    fill: "#8f8f94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M10.755.02c5.561-.367,9.772,4.434,9.4,10.722S14.988,22.425,9.427,22.792-.345,18.359.022,12.07,5.195.387,10.755.02Z",
    transform: "translate(243.598 484.064) rotate(-22.62)",
    fill: "#aaa9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M315.872,399.956H274.31V376.63h41.044Z",
    transform: "translate(-18.058 102.386)",
    fill: "#aaa9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M10.32.008c5.463-.232,9.7,4.757,9.472,11.144S14.944,22.9,9.481,23.135-.223,18.378.009,11.991,4.857.24,10.32.008Z",
    transform: "matrix(0.973, -0.231, 0.231, 0.973, 284.94, 481.723)",
    fill: "#a1a0a6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 7.836,
    cy: 9.333,
    rx: 7.836,
    ry: 9.333,
    transform: "translate(289.419 481.345)",
    fill: "#8f8f94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M266.177,388.157c0,6.449-4.389,11.677-9.8,11.677s-9.8-5.228-9.8-11.677,4.389-11.677,9.8-11.677,9.8,5.228,9.8,11.677Z",
    transform: "translate(-22.168 102.33)",
    fill: "#bababf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 42.563,
    height: 23.34,
    transform: "translate(233.153 478.769)",
    fill: "#bababf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M300.947,388.157c0,6.449-4.389,11.677-9.8,11.677s-9.8-5.228-9.8-11.677,4.389-11.677,9.8-11.677a9.069,9.069,0,0,1,6.936,3.416A12.884,12.884,0,0,1,300.947,388.157Z",
    transform: "translate(-16.999 102.33)",
    fill: "#a1a0a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M298.722,387.523c0,5.155-3.508,9.333-7.836,9.333s-7.836-4.179-7.836-9.333,3.508-9.333,7.836-9.333a7.247,7.247,0,0,1,5.544,2.73,10.3,10.3,0,0,1,2.292,6.6Z",
    transform: "translate(-16.743 102.964)",
    fill: "#8f8f94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 9.792,
    cy: 11.663,
    rx: 9.792,
    ry: 11.663,
    transform: "translate(237.324 455.95)",
    fill: "#c6c5cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 42.563,
    height: 23.326,
    transform: "translate(246.063 455.95)",
    fill: "#c6c5cc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 9.792,
    cy: 11.663,
    rx: 9.792,
    ry: 11.663,
    transform: "translate(277.263 455.95)",
    fill: "#a1a0a6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 7.836,
    cy: 9.333,
    rx: 7.836,
    ry: 9.333,
    transform: "translate(279.219 458.28)",
    fill: "#8f8f94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M11.991.009c6.386-.232,11.376,4.009,11.144,9.472s-5.6,10.08-11.983,10.311S-.224,15.783.008,10.32,5.6.241,11.991.009Z",
    transform: "matrix(0.231, -0.973, 0.973, 0.231, 221.576, 522.005)",
    fill: "#c6c5cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M295.46,416.29H253.91V392.95h41.044Z",
    transform: "translate(-21.09 108.432)",
    fill: "#c6c5cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M10.744.019c5.558-.364,9.768,4.442,9.4,10.733S14.984,22.439,9.427,22.8-.342,18.361.022,12.07,5.186.383,10.744.019Z",
    transform: "translate(260.175 506.325) rotate(-22.38)",
    fill: "#a1a0a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M298.442,403.993c0,5.155-3.508,9.333-7.836,9.333s-7.836-4.179-7.836-9.333,3.508-9.333,7.836-9.333,7.836,4.179,7.836,9.333Z",
    transform: "translate(-16.784 109.066)",
    fill: "#8f8f94"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 48.627,
    height: 154.649,
    transform: "translate(478.324 370.567)",
    fill: "#b1b1b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 8.423,
    height: 12.047,
    transform: "translate(481.852 375.034)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 8.423,
    height: 12.047,
    transform: "translate(492.719 375.034)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 8.423,
    height: 12.047,
    transform: "translate(503.574 375.034)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 8.423,
    height: 12.047,
    transform: "translate(514.44 375.034)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 8.423,
    height: 12.047,
    transform: "translate(481.852 393.084)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 8.423,
    height: 12.047,
    transform: "translate(492.719 393.084)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 8.423,
    height: 12.047,
    transform: "translate(503.574 393.084)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 8.423,
    height: 12.047,
    transform: "translate(514.44 393.084)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 8.423,
    height: 12.047,
    transform: "translate(481.852 411.134)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 8.423,
    height: 12.047,
    transform: "translate(492.719 411.134)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 8.423,
    height: 12.047,
    transform: "translate(503.574 411.134)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 8.423,
    height: 12.047,
    transform: "translate(514.44 411.134)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 8.423,
    height: 12.047,
    transform: "translate(481.852 429.17)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 8.423,
    height: 12.047,
    transform: "translate(492.719 429.17)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 8.423,
    height: 12.047,
    transform: "translate(503.574 429.17)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 8.423,
    height: 12.047,
    transform: "translate(514.44 429.17)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 8.423,
    height: 12.047,
    transform: "translate(481.852 447.22)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 8.423,
    height: 12.047,
    transform: "translate(492.719 447.22)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 8.423,
    height: 12.047,
    transform: "translate(503.574 447.22)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 8.423,
    height: 12.047,
    transform: "translate(514.44 447.22)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 8.423,
    height: 12.047,
    transform: "translate(481.852 465.269)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 8.423,
    height: 12.047,
    transform: "translate(492.719 465.269)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 8.423,
    height: 12.047,
    transform: "translate(503.574 465.269)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 8.423,
    height: 12.047,
    transform: "translate(514.44 465.269)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 8.423,
    height: 12.047,
    transform: "translate(481.852 483.319)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 8.423,
    height: 12.047,
    transform: "translate(492.719 483.319)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 8.423,
    height: 12.047,
    transform: "translate(503.574 483.319)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 8.423,
    height: 12.047,
    transform: "translate(514.44 483.319)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 8.423,
    height: 12.047,
    transform: "translate(481.852 501.369)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 18.468,
    height: 23.861,
    transform: "translate(492.707 501.369)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 8.423,
    height: 12.047,
    transform: "translate(514.44 501.369)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M322.87,373.25l6.386,42.65,4.568-.63,14.936-28.356Z",
    transform: "translate(-10.83 101.133)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M373.577,330.24s-19.63,6.14-25,11.293-7.433,11.225-12.784,14.61-12.347,15.487-11.967,21.407a62.053,62.053,0,0,0,2.727,12.979l16.19,10.9L370.286,371.6l12.864-23.381-3.8-12.019Z",
    transform: "translate(-10.718 85.197)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M318.189,395.42l29.5,24.45a2.782,2.782,0,0,0,.357.247,1.715,1.715,0,0,0,2.083-.439l53.655-59.563a2.525,2.525,0,0,0,.628-1.619,2.585,2.585,0,0,0-.524-1.67L377.7,323.4a2.67,2.67,0,0,1,.1-3.3l9.366-10.388a2.655,2.655,0,0,0,.092-3.276,1.821,1.821,0,0,0-1.353-.747,1.768,1.768,0,0,0-1.4.623l-20.39,22.614a2.544,2.544,0,0,0-.587,2.028l.932,7.881a2.619,2.619,0,0,1-.6,2.028L317.982,391.8a2.578,2.578,0,0,0-.623,1.868A2.459,2.459,0,0,0,318.189,395.42Z",
    transform: "translate(-11.7 76.099)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M377.57,360.237l9.5-10.539a5,5,0,0,0,.184-6.195l-3.371-4.3-12.2,13.527Z",
    transform: "translate(-3.565 88.517)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M.821,1.588,18.963,0l-.821,9.5L0,11.088Z",
    transform: "translate(351.788 456.998) rotate(-42.98)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M.821,1.588,18.963,0l-.821,9.5L0,11.088Z",
    transform: "translate(337.121 473.304) rotate(-42.98)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M336.92,383.922l4.6,3.81a3.537,3.537,0,0,0,5.028-.425l4.419-4.906-5.9-7.51Z",
    transform: "translate(-8.732 101.741)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M371.88,354.777l12.2-13.527-8.872-11.334a3.8,3.8,0,0,0-6.007-.26l-9.079,10.087Z",
    transform: "translate(-5.292 84.48)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M1.645,1.588,19.786,0,18.141,19.025,0,20.613Z",
    transform: "translate(337.874 440.529) rotate(-42.98)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M1.641,1.584,19.739,0,18.1,18.981,0,20.565Z",
    transform: "matrix(0.732, -0.682, 0.682, 0.732, 321.9, 456.87)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M323.422,375.268c.84.781,2.37,2.1,2.577,2.275l4.5,3.8,4.4,3.714,2.232,1.891,8.492-9.429-11.76-15.076-10.989,12.2A4.482,4.482,0,0,0,323.422,375.268Z",
    transform: "translate(-10.828 97.128)",
    fill: "#9a999e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M0,0,3.8.329A2.95,2.95,0,0,1,6.409,2.9l1.1,12.528L1.316,14.9.013,0Z",
    transform: "translate(380.232 430.242) rotate(47.02)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M0,0,6.189.535l1.3,14.871L1.3,14.871Z",
    transform: "translate(365.538 446.552) rotate(47.02)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M0,0,6.189.535l1.3,14.871L1.3,14.871Z",
    transform: "translate(350.875 462.858) rotate(47.02)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M348.506,381.633l-3.832-4.893-5.684,6.3,3.061,2.535a2.217,2.217,0,0,0,3.13-.26Z",
    transform: "translate(-8.421 102.426)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M2.769.012l12.683,1.1,1.3,14.871-15.7-1.358L.011,2.732A2.442,2.442,0,0,1,2.769.012Z",
    transform: "translate(366.9 413.58) rotate(47.02)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M0,0,15.7,1.358,17,16.229,1.3,14.871Z",
    transform: "translate(352.239 429.514) rotate(47.02)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M0,0,15.7,1.358,17,16.229,1.3,14.871Z",
    transform: "translate(337.576 445.833) rotate(47.02)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M343.19,376.737l-9.712-12.417-8.618,9.594c.748.672,1.565,1.371,1.715,1.508l10.126,8.552Z",
    transform: "translate(-10.529 97.825)",
    fill: "#7f7e82"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 3.475,
    height: 38.854,
    transform: "translate(367.079 457.581)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 18.595,
    height: 19.516,
    transform: "translate(417.054 509.222) rotate(180)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M406.9,386.61v15.363H355.19V387.747Z",
    transform: "translate(-6.049 106.083)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M390,404.628l-9.654-15.418H341l-4.476,7.7V401.7a2.729,2.729,0,0,0,2.462,2.933Z",
    transform: "translate(-8.824 107.047)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M338.221,400.242v.178c0,3.028,2.061,5.482,4.6,5.482h72.641c2.542,0,4.6-2.454,4.6-5.482v-.178a4.189,4.189,0,0,0,0-.672c-.286-2.763-2.266-4.831-4.6-4.81h-72.63c-2.337-.021-4.316,2.048-4.6,4.81A4.167,4.167,0,0,0,338.221,400.242Z",
    transform: "translate(-8.599 109.103)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M403.52,403.984v4.961h42.4c2.969,0,5.392-2.826,5.454-6.361v-8.153a8.776,8.776,0,0,0-1.07-4.262,6.361,6.361,0,0,0-5.5-3.55H418.1c-5.117,0-9.861,3.191-12.5,8.415a16.687,16.687,0,0,0-1.151,2.741,19.214,19.214,0,0,0-.921,4.811C403.543,403.052,403.52,403.587,403.52,403.984Z",
    transform: "translate(1.135 106.087)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M338.22,398.949v.178c0,3.028,2.061,5.482,4.6,5.482H455.749c2.969,0,5.392-2.826,5.454-6.361H338.266a4.161,4.161,0,0,0-.046.7Z",
    transform: "translate(-8.64 110.396)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M405.33,394.075H451.1v-.6a8.777,8.777,0,0,0-1.07-4.262H408.989a16.755,16.755,0,0,0-3.659,4.865Z",
    transform: "translate(1.406 107.047)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M358.31,404.124c0,7.488,5.1,13.557,11.384,13.554s11.38-6.076,11.376-13.564-5.105-13.553-11.392-13.545a10.534,10.534,0,0,0-8.043,3.971,14.959,14.959,0,0,0-3.326,9.584Z",
    transform: "translate(-5.56 107.551)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M363.36,402.253c0,3.665,2.5,6.636,5.573,6.633s5.57-2.977,5.565-6.642-2.5-6.632-5.581-6.624a5.15,5.15,0,0,0-3.934,1.944,7.315,7.315,0,0,0-1.624,4.69Z",
    transform: "translate(-4.799 109.422)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M365.61,401.416a3.014,3.014,0,1,0,2.969-3.536,3.29,3.29,0,0,0-2.969,3.536Z",
    transform: "translate(-4.46 110.259)",
    fill: "#c28101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M337.89,404.124c0,7.486,5.1,13.554,11.38,13.554s11.38-6.069,11.38-13.554-5.1-13.554-11.38-13.554a10.53,10.53,0,0,0-8.05,3.966A14.957,14.957,0,0,0,337.89,404.124Z",
    transform: "translate(-8.595 107.551)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M342.94,402.253c0,3.663,2.493,6.633,5.569,6.633s5.569-2.97,5.569-6.633-2.493-6.633-5.569-6.633S342.94,398.59,342.94,402.253Z",
    transform: "translate(-7.835 109.422)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M345.2,401.416a3.014,3.014,0,1,0,2.969-3.536,2.738,2.738,0,0,0-2.1,1.032,3.893,3.893,0,0,0-.866,2.5Z",
    transform: "translate(-7.495 110.259)",
    fill: "#c28101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M335.014,402.368a2.228,2.228,0,0,0,1.876-1.192l4.833-8.538H380.73l5.42,8.648a2.027,2.027,0,0,0,2.932.178,3.084,3.084,0,0,0,.692-3.4l-6.11-9.772a2.2,2.2,0,0,0-1.807-1.083H340.526a2.228,2.228,0,0,0-1.876,1.192l-5.512,9.731a3.085,3.085,0,0,0,.61,3.742A2.063,2.063,0,0,0,335.014,402.368Z",
    transform: "translate(-9.385 106.306)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M407.86,363.245V392.19a9.641,9.641,0,0,0,2.151,6.178,6.787,6.787,0,0,0,5.19,2.552h30.447c3.819,0,7-3.485,7.318-8.018,0-.233,0-.48,0-.713v-7.785a10,10,0,0,0-.794-3.947l-.472-1.11-7.824-18.488-.242-.562a7.391,7.391,0,0,0-6.271-4.8l-13.969-.644-7.94-.356a6.75,6.75,0,0,0-5.352,2.456A9.641,9.641,0,0,0,407.86,363.245Z",
    transform: "translate(1.783 94.185)",
    fill: "#ffa200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M419.05,367.159c0,15.007,10.851,27.164,24.245,27.164a21.9,21.9,0,0,0,7.986-1.507v-8.5a10,10,0,0,0-.794-3.947l-.472-1.11-7.824-18.488-.242-.562a7.391,7.391,0,0,0-6.271-4.8l-13.969-.644a29.412,29.412,0,0,0-2.658,12.389Z",
    transform: "translate(3.459 94.286)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 11.288,
    height: 2.412,
    transform: "translate(424.622 477.124)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M420.87,365.879v5.688c0,3.709,2.524,6.715,5.638,6.715h20.839a4.9,4.9,0,0,0,2.416-.644l-.736-1.727-6.26-14.8-.828-1.96h-15.43c-3.116.008-5.638,3.018-5.638,6.729Z",
    transform: "translate(3.733 95.909)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M424.31,364.2v7.428a2.8,2.8,0,0,0,2.681,2.892h17.49a3.9,3.9,0,0,0,1.151-.151l-6.087-13.075H427a2.55,2.55,0,0,0-2.152,1.206A2.891,2.891,0,0,0,424.31,364.2Z",
    transform: "translate(4.253 96.702)",
    fill: "#0086fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M430.13,361.29l8.319,13.225h3.464l-8.469-13.225Z",
    transform: "translate(5.128 96.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M424.78,362.5l7.56,12.019h3.452l-8.457-13.226h-.414a2.552,2.552,0,0,0-2.14,1.206Z",
    transform: "translate(4.333 96.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 33.128,
    height: 2.097,
    transform: "translate(448.434 486.814) rotate(180)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 33.128,
    height: 1.055,
    transform: "translate(448.434 489.13) rotate(180)",
    fill: "#ffaf24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M416.64,404.124c0,7.486,5.1,13.554,11.38,13.554s11.38-6.069,11.38-13.554-5.1-13.554-11.38-13.554a10.53,10.53,0,0,0-8.05,3.966,14.957,14.957,0,0,0-3.33,9.588Z",
    transform: "translate(3.111 107.551)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M421.69,402.253c0,3.663,2.493,6.633,5.569,6.633s5.569-2.97,5.569-6.633-2.493-6.633-5.569-6.633S421.69,398.59,421.69,402.253Z",
    transform: "translate(3.874 109.422)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M424,401.416a3.014,3.014,0,1,0,2.969-3.536,2.739,2.739,0,0,0-2.1,1.032,3.892,3.892,0,0,0-.866,2.5Z",
    transform: "translate(4.222 110.259)",
    fill: "#c28101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M415.032,408.393a2.55,2.55,0,0,0,2.3-2.741c0-7.433,5.059-13.458,11.3-13.458s11.3,6.026,11.3,13.458a2.256,2.256,0,0,0,4.511,0c.155-6.851-2.825-13.263-7.782-16.743a13.669,13.669,0,0,0-16.067,0c-4.957,3.48-7.937,9.891-7.782,16.743A2.57,2.57,0,0,0,415.032,408.393Z",
    transform: "translate(2.532 105.968)",
    fill: "#4a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M321.81,373.76l4.476,25.286,2.854-.891-4.419-22.846Z",
    transform: "translate(-10.974 101.322)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 90.557,
    height: 13.801,
    transform: "translate(239.737 510.921)",
    fill: "#ffa40a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M274.907,399.91,259.96,410.627v-5.88l6.743-4.838Z",
    transform: "translate(-20.175 111.011)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M291.949,399.91l-19.228,13.8H264.54l19.228-13.8Z",
    transform: "translate(-19.501 111.011)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M307.38,399.91l-19.228,13.8H279.96l19.239-13.8Z",
    transform: "translate(-17.209 111.011)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M322.8,399.91l-19.228,13.8H295.39l19.228-13.8Z",
    transform: "translate(-14.916 111.011)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M338.229,399.91,319,413.711H310.82l19.228-13.8Z",
    transform: "translate(-12.622 111.011)",
    fill: "#646469"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M340.533,402.5v5.866l-6.1,4.386h-8.2Z",
    transform: "translate(-10.322 111.971)",
    fill: "#646469"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5cdf341a.svg";
export { ForwardRef as ReactComponent };